module.exports = __webpack_public_path__ + "static/media/error_bg.8593afb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/error_bg.png
// module id = 1485
// module chunks = 10